<template>
  <div>
    <b-row >
      <b-col cols="12" md="4" class="mb-4">
        <b-media no-body>
          <b-media-aside class="mr-2">
            <b-avatar size="40" variant="primary">
              <feather-icon size="20" icon="UserIcon" />
            </b-avatar>
          </b-media-aside>
          <b-media-body class="my-auto">
            <h4 class="font-weight-bolder mb-0">
              {{ userData.lastName }} {{ userData.firstName }}
            </h4>
            <b-card-text class="font-small-3 mb-0">
              Nom et prénom du salarié
            </b-card-text>
          </b-media-body>
        </b-media>
      </b-col>

      <b-col cols="12" md="4" class="mb-4">
        <b-media no-body>
          <b-media-aside class="mr-2">
            <b-avatar size="40" variant="success">
              <feather-icon size="20" icon="BriefcaseIcon" />
            </b-avatar>
          </b-media-aside>
          <b-media-body class="my-auto">
            <h4 class="font-weight-bolder mb-0">
              {{ userData.fonction ? userData.fonction : '' }}

            </h4>
            <b-card-text class="font-small-3 mb-0">
              Intitulé du poste
            </b-card-text>
          </b-media-body>
        </b-media>
      </b-col>

      <b-col cols="12" md="4" class="mb-4">
        <b-media no-body>
          <b-media-aside class="mr-2">
            <b-avatar size="40" variant="info">
              <feather-icon size="20" icon="CalendarIcon" />
            </b-avatar>
          </b-media-aside>
          <b-media-body class="my-auto">
            <h4 class="font-weight-bolder mb-0">
              {{ formatDate(userData.fonctionDate ? userData.fonctionDate : '') }}

            </h4>
            <b-card-text class="font-small-3 mb-0">
              Date d'embauche
            </b-card-text>
          </b-media-body>
        </b-media>
      </b-col>

      <b-col cols="12" md="4" class="mb-4" v-if ="userData.directions">
        <b-media no-body>
          <b-media-aside class="mr-2">
            <b-avatar size="40" variant="warning">
              <feather-icon size="20" icon="MapPinIcon" />
            </b-avatar>
          </b-media-aside>
          <b-media-body class="my-auto" >
            <h4 class="font-weight-bolder mb-0">
              {{ userData.directions ? userData.directions.name : '' }}
            </h4>
            <b-card-text class="font-small-3 mb-0">
              <!-- Direction/Cellule -->
              {{ userData.directions.type }}

            </b-card-text>
          </b-media-body>
        </b-media>
      </b-col>

      <b-col cols="12" md="4" class="mb-4" v-if="userData.services && userData.services.name">
        <b-media no-body>
          <b-media-aside class="mr-2">
            <b-avatar size="40" variant="danger">
              <feather-icon size="20" icon="SettingsIcon" />
            </b-avatar>
          </b-media-aside>
          <b-media-body class="my-auto">
            <h4 class="font-weight-bolder mb-0">
              {{ userData.services ? userData.services.name : '' }}
            </h4>
            <b-card-text class="font-small-3 mb-0">
              Services
            </b-card-text>
          </b-media-body>
        </b-media>
      </b-col>

      <b-col cols="12" md="4" class="mb-4" v-if="userData.toll">
        <b-media no-body>
          <b-media-aside class="mr-2">
            <b-avatar size="40" variant="secondary">
              <feather-icon size="20" icon="HomeIcon" />
            </b-avatar>
          </b-media-aside>
          <b-media-body class="my-auto">
            <h4 class="font-weight-bolder mb-0">
              {{ userData.toll ? userData.toll.name : '' }}
            </h4>
            <b-card-text class="font-small-3 mb-0">
              Péage
            </b-card-text>
          </b-media-body>
        </b-media>
      </b-col>
    </b-row>

    <hr>
    <b-card no-body class="border mt-1 mb-12">
      <b-card-header class="p-1">
        <b-card-title class="font-medium-2">
          <feather-icon icon="UserCheckIcon" size="18" />
          <span class="align-middle ml-50">Manager (N+1)</span>
        </b-card-title>
      </b-card-header>
      <b-table ref="refUserListTable" :items="userData.usersHierarchique" responsive :fields="tableColumns" primary-key="id"
        :sort-by.sync="sortBy" show-empty empty-text="Aucun enregistrements correspondants trouvés" :sort-desc.sync="isSortDirDesc"
        class="position-relative">
        <template #cell(user)="data">
          <b-media vertical-align="center">
            <template #aside>
              <b-avatar size="40" variant="light-primary" class="badge-minimal" badge-variant="success">
                {{ getUserInitials(data.item) }}
              </b-avatar>
            </template>
            <span class="font-weight-bold d-block text-nowrap">{{ data.item.lastName + ' ' + data.item.firstName
              }}</span>
            <small class="text-muted">{{ data.item.mail }}</small>
          </b-media>
        </template>

        <template #cell(fonction)="data">
          <b-media vertical-align="center">
            <span class="font-weight-bold d-block text-nowrap">{{ data.item.fonction }}</span>
            <!-- <small v-if="data.item.directions">{{ data.item.directions.name }}</small> -->
          </b-media>
        </template>

        <template #cell(direction)="data">
          <span v-if="data.item.directions  && data.item.directions.name" class="text-nowrap">{{ data.item.directions.name }}</span>
        </template>

        <template #cell(services)="data" >
          <span v-if="data.item.services && data.item.services.name" class="text-nowrap">{{ data.item.services.name }}</span>
        </template>

      </b-table>
    </b-card>
  </div>
</template>

<script>
import {
  BMedia,
  BAvatar,
  BRow,
  BCol,
  BTable,
  BCard,
  BCardHeader,
  BCardTitle,
  BCardBody,
  BCardText,
  BMediaAside,
  BMediaBody
} from 'bootstrap-vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import { ref } from '@vue/composition-api'

export default {
  components: {
    BMedia,
    BAvatar,
    BRow,
    BCol,
    BTable,
    BCard,
    BCardHeader,
    BCardTitle,
    // BCardBody,
     BCardText,
    // BMediaAside,
    // BMediaBody,
    FeatherIcon
  },
  props: {
    userData: {
      type: Object,
      required: true
    }
  },
  // setup(props) {
  //   const usersHierarchique = ref(props.userData.usersHierarchique.map(user => ({
  //     ...user,
  //     initials: (user.firstName ? user.firstName.charAt(0) : '') + (user.lastName ? user.lastName.charAt(0) : '')
  //   })))

  //   return {
  //     usersHierarchique
  //   }
  // },
  data() {
    return {
      perPage: 10,
      perPageOptions: [10, 25, 50, 100],
      searchQuery: '',
      // tableColumns: [
      //   { key: 'user', label: 'Nom Prénom(s)', sortable: true },
      //   { key: 'fonction', label: 'Fonction', sortable: true },
      //   // { key: 'direction', label: 'Direction', sortable: true },

      //   { key: 'services', label: 'Services', sortable: true },
      // ],
      sortBy: 'id',
      isSortDirDesc: true,
      totalUsers: 0,
      currentPage: 1,
      users: []
    }
  },
  computed: {
    tableColumns() {
      const columns = [
        { key: 'user', label: 'Nom Prénom(s)', sortable: true },
        { key: 'fonction', label: 'Fonction', sortable: true },
        // { key: 'direction', label: 'Direction', sortable: true }
      ]
      if (this.userData.directions && this.userData.directions.name) {
        columns.push({ key: 'direction', label: this.userData.directions.type, sortable: true })

      }

      if (this.userData.services && this.userData.services.name) {

        columns.push({ key: 'services', label: 'Services', sortable: true })
      }


      return columns
    }
  },
  methods: {
    getUserInitials(user) {
      const firstInitial = user.firstName ? user.firstName.charAt(0).toUpperCase() : ''
      const lastInitial = user.lastName ? user.lastName.charAt(0).toUpperCase() : ''
      return `${lastInitial}${firstInitial}`
    },

    formatDate(date) {
  if (!date) return '';

  if (Array.isArray(date)) {
    const [year, month, day] = date;
    return `${day.toString().padStart(2, '0')}-${month.toString().padStart(2, '0')}-${year}`;
  }

  if (typeof date === 'string') {
    // Supprimer l'heure si présente
    date = date.split(' ')[0]; // Supprime l'heure si "DD-MM-YYYY HH:MM:SS"
    date = date.split('T')[0]; // Supprime l'heure si "YYYY-MM-DDTHH:MM:SS"

    const [day, month, year] = date.split('-');
    const fullYear = year.length === 2 ? `20${year}` : year;

    return `${day}-${month}-${fullYear}`;
  }

  return '';
},
  //   formatDate(date) {
  //   if (!date) return '';

  //   // Check if date is an array
  //   if (Array.isArray(date)) {
  //     const [year, month, day] = date;
  //     return `${day.toString().padStart(2, '0')}-${month.toString().padStart(2, '0')}-${year}`;
  //   }

  //   // Check if date is a string
  //   if (typeof date === 'string') {
  //     const [year, month, day] = date.split('-');
  //     return `${day}-${month}-${year}`;
  //   }

  //   // Handle invalid date format
  //   console.error('Invalid date format:', date);
  //   return '';
  // },
  }
  // computed: {
  //   getUserInitials(user) {
  //     const firstInitial = user.firstName ? user.firstName.charAt(0).toUpperCase() : '';
  //     const lastInitial = user.lastName ? user.lastName.charAt(0).toUpperCase() : '';
  //     return `${firstInitial}${lastInitial}`;
  //   },
  //   // userInitials() {
  //   //   const { firstName, lastName } = this.userData
  //   //   const firstInitial = firstName ? firstName.charAt(0).toUpperCase() : ''
  //   //   const lastInitial = lastName ? lastName.charAt(0).toUpperCase() : ''
  //   //   return `${firstInitial}${lastInitial}`
  //   // }
  // }
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/dashboard-ecommerce.scss';
@import '@core/scss/vue/libs/chart-apex.scss';
// @import '@core/scss/vue/libs/vue-select.scss';
// @import '@core/scss/vue/libs/vue-flatpicker.scss';

// .form-item-action-col {
//   width: 100%;
// }

// .repeater-form {
//     transition: .35s height;
//   }

// .dark-layout {
//   .form-item-section {
//     background-color: $theme-dark-body-bg;

//     .row .border {
//       background-color: $theme-dark-card-bg;
//     }
//   }
// }</style>
